import { render, staticRenderFns } from "./GoBroadToGoNarrow12.vue?vue&type=template&id=23fd2cec&scoped=true&"
import script from "./GoBroadToGoNarrow12.vue?vue&type=script&lang=js&"
export * from "./GoBroadToGoNarrow12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fd2cec",
  null
  
)

export default component.exports